import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import Home24Timeleft from './Home24Timeleft.vue'
registerVueComponentAndAngularBindings('home24:timeleft', 'home24Timeleft', Home24Timeleft); 